import { Box, ListItemButton, Typography } from "@mui/material";
import * as React from "react";
import { ITreeNode } from "ui/Scripts/source/models/common/treeNode";
import { ListStateIconCanceled } from "../../List/ListStateIconCanceled";
import { ListStateIconExpanded } from "../../List/ListStateIconExpanded";
import { ListStateIconHome } from "../../List/ListStateIconHome";

export interface IUiTreeNodeProp {
  classes?: string;
  node: ITreeNode;
  selectedId?: string;
  isFirstNode: boolean;
  hideDisabledIcon?: boolean;
  onClick: (id: string) => void;
  onDoubleClick: () => void;
  onSetCollapsed: (id: string, value: boolean) => void;
}

export class UiTreeNode extends React.Component<IUiTreeNodeProp, {}> {
    handleNodeClick = (e) => {
        const props = this.props;
        e.stopPropagation();
        if (props.node.disabled) return;
        props.onClick(props.node.id);
    };

    handleNodeDoubleClick = (e) => {
        const props = this.props;
        e.stopPropagation();
        if (props.node.disabled) return;
        props.onDoubleClick();
    };

    render() {
        const props = this.props;
        const node = props.node;
        if (!node || (node.parent && node.getAncesterIsCollapsed())) return null;
        const hasChildren = node.children.length > 0;
        const isRoot = node.getIsRoot();
        let selectedId = props.selectedId;
        if (!props.selectedId && isRoot) {
            selectedId = node.id;
        }
        return (
            <ListItemButton
                selected={selectedId === node.id}
                disabled={node.disabled}
                onClick={this.handleNodeClick}
                onDoubleClick={props.onDoubleClick ? this.handleNodeDoubleClick : null}
            >
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="flex-start"
                    sx={{ marginLeft: (10 * node.level).toString(10) + "px" }}
                >
                    {!isRoot && !props.isFirstNode && (
                        <ListStateIconExpanded
                            collapsed={node.collapsed}
                            hasChildren={hasChildren}
                            noMargin
                            onClick={
                                hasChildren
                                    ? () => props.onSetCollapsed(node.id, !node.collapsed)
                                    : null
                            }
                        />
                    )}
                    <ListStateIconHome />
                    {!props.hideDisabledIcon && node.disabled ? <ListStateIconCanceled /> : null}
                    <Typography
                        sx={{
                            fontWeight: selectedId === node.id ? 600 : 400,
                            marginLeft: ".5rem",
                        }}
                    >
                        {node.name}
                    </Typography>
                </Box>
            </ListItemButton>
        );
    }
}
